import styled from 'styled-components';

export const PersonalInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
)

export const PersonalDetailsWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        
    `
);

export const PersonalDetailsHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        position:relative;

        span{
            position: absolute;
            top:50%;
            right:0;
            width:80%;
            height:0.1rem;
            background-color: rgba(0,0,0,0.5);
        }

        @media(max-width:1023px){
            span{
                width:65%;
            }
        }
    `
);

export const PersonalDetailsHeadText = styled.p(
    props => `
        font-size: 1.2rem;
        color: #4c4c4c;
        font-weight: bold;
        text-transform: uppercase;
    `
);

export const PersonalDetailsInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top:2rem;
    `
);

export const TitleNameWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-bottom:${props.theme.spacing.large.l15};
        @media only screen and (min-width:320px) and (max-width: 1023px){
            padding-bottom: ${props.theme.spacing.base};
        }
    `
)

export const TitleWrapper = styled.div(
    props => `
          width:9.5rem;
          position: relative;
          flex-direction: column;
      `,
);

export const FullNameWrapper = styled.div(
    props => `
        width: 90%;
        padding-left: ${props.theme.spacing.base};
        flex-direction: column;
    `,
);

export const EmailWrapper = styled.div(
    props => `
        width: 100%;
        flex-direction: column;
    `,
);

export const InfoText = styled.span(
    props => `
        width:100%;
        margin-top:0.2rem;
        font-size: 1.2rem;
        color: #1c7c2c;
        display: block;
    `
)